import { HotelPeriodType } from '@api/v3';

export const periodTypeViewver = (periodType: HotelPeriodType) => {
  switch (periodType) {
    case HotelPeriodType.DAY:
      return 'Günün Oteli';
    case HotelPeriodType.WEEK:
      return 'Haftanın Oteli';
    case HotelPeriodType.MONTH:
      return 'Ayın Oteli';
  }
};
